/* eslint-disable camelcase */
export default {
  metrics: "Метрики",
};
